import { FC, ReactNode, useEffect } from 'react';
import { useSubject }               from 'View/HookApi';
import { Select }                   from '../Select/Select';
import { debounceTime }             from 'rxjs';
import { useDispatch, useSelector } from 'react-redux';
import { IFilterSettings }          from 'Domain/Repositories/BaseRepository/BaseRepository';
import { UnknownAction }            from 'redux';
import { TRootState }               from 'Redux/Reducers';
import { IFilterProps }             from 'Utils';
import { AnyObject }                from 'antd/es/_util/type';

type TProps = {
  searchField?: string,
  fetchAction: (payload: IFilterSettings) => UnknownAction,
  dataQuery: (state: TRootState, filter?: null | IFilterProps<any>) => AnyObject[],
  isLoading: (state: TRootState) => boolean,
  onChange?: (value: string) => void,
  defaultValue?: string,
  value?: string,
  placeholder?: string,
  renderLabel?: (entry: any) => ReactNode
};

export const RemoteSelect: FC<TProps> = ({ fetchAction, onChange, renderLabel, isLoading, dataQuery, searchField = 'name', ...props }) => {

  const dispatch = useDispatch();

  const loading = useSelector(isLoading);
  const data = useSelector(dataQuery);

  const request = ({ field, value }: { field: string, value: string | number | boolean }) => {
    if(`${value}`.trim() === '') {
      return dispatch(fetchAction({ filter: [], pagination: { page: 1, take: 100 } }));
    }
    dispatch(fetchAction({ filter: [{ field, value: `%${value}%` }], pagination: { page: 1, take: 100 } }));
  };

  const onSearch$ = useSubject((value: string) => {
    request({ field: searchField, value });
  }, [], debounceTime(500));

  useEffect(() => {
    onSearch$.next('');
  }, []);

  const handleOnChange = (value: string) => {
    onChange && onChange(value);
  }

  return (
    <Select
      options={data.map((entry: AnyObject) => ({
        value: entry.id,
        label: renderLabel ? renderLabel(entry) : entry[searchField],
      }))}
      loading={loading}
      onSearch={onSearch$.next.bind(onSearch$)}
      filterOption={false}
      onChange={handleOnChange}
      allowClear
      showSearch
      placeholder={'Datensatz auswählen ... '}
      defaultActiveFirstOption={false}
      {...props}
    />
  );

};
